import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import api from '../../lib/api';

/**
 * Normalize a phone number to WhatsApp's required international format
 * (country code, no leading 0, digits only). Defaults to Turkey (+90).
 * Examples:
 *   "05326471903"      -> "905326471903"
 *   "0532 647 19 03"   -> "905326471903"
 *   "+90 532 647 1903" -> "905326471903"
 *   "5326471903"       -> "905326471903"
 *   "905326471903"     -> "905326471903"
 */
export const normalizeWhatsApp = (raw) => {
  let n = (raw || '').replace(/[^0-9]/g, '');
  if (!n) return '';
  if (n.startsWith('00')) n = n.slice(2);        // "00" international prefix
  if (n.startsWith('0')) n = '90' + n.slice(1);  // local TR number -> add country code
  else if (n.length === 10) n = '90' + n;        // 10-digit w/o code -> assume TR
  return n;
};

export const WhatsAppButton = () => {
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    api.get('/settings/contact').then(r => {
      if (r.data?.whatsapp) setWhatsapp(r.data.whatsapp);
    }).catch(() => {});
  }, []);

  const number = normalizeWhatsApp(whatsapp);
  if (!number) return null;

  return (
    <a
      href={`https://wa.me/${number}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 p-4 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 active:scale-95 transition-transform duration-200"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};
